import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
/** Services Import */
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
import IndexedDb from "../../services/IndexedDb/IndexedDb";
/** Components Import */
import { Loading, Dialog } from "../../Components/Bootstrap";
import { Navbar, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/** Icons Import */
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";

function Notices({}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [noticeList, setNoticeList] = useState([]);
  const [noticeDetails, setNoticeDetails] = useState({});
  const [dialogToggle, setDialogToggle] = useState(false);

  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    if (noticeDetails.contents) {
      document.getElementById("notice-detail-contents").innerHTML =
        noticeDetails.contents;
    }
  }, [noticeDetails]);

  const Init = async () => {
    try {
      SelectLogic();
    } catch (e) {
      console.log("Error: ", e.message);
      Commons.Toast("error", e.message);
    }
  };

  // 공지사항 조회
  const SelectLogic = async () => {
    setLoading(true);
    let _noticeList = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Common.Notice
      ).then((result) => {
        let data = result.data;
        // console.log("공지사항 조회: ", data);

        if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _noticeList.push(data[i]);
          }
          setNoticeList(_noticeList.reverse());
        }
      });
    } catch (e) {
      console.log("Error: ", e.message);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 공지사항 상세 조회
  const SelectLogic1 = async (_seq) => {
    setLoading(true);
    let _noticeDetails = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Common.NOticeDetail,
        {
          seq: _seq,
        }
      ).then((result) => {
        let data = result.data;
        // console.log("공지사항 상세 조회: ", data);

        if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.length > 0) {
          setNoticeDetails({ ...data[0] });
          setDialogToggle(true);
        }
      });
    } catch (e) {
      console.log("Error: ", e.message);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Navbar>
        <Navbar.Brand onClick={() => navigate("/Setting")}>
          <FontAwesomeIcon icon={faAngleLeft} />
        </Navbar.Brand>
      </Navbar>
      {noticeList.map((item, index) => {
        return (
          <Card
            key={index}
            className="mb-2"
            onClick={() => SelectLogic1(item.seq)}
          >
            <Card.Body>{item.subject}</Card.Body>
          </Card>
        );
      })}
      <Dialog
        title={noticeDetails.subject}
        fullscreen
        show={dialogToggle}
        onHide={() => setDialogToggle(false)}
        sumitButton={false}
      >
        <div id="notice-detail-contents"></div>
      </Dialog>
      <Loading show={loading} />
    </React.Fragment>
  );
}

export default Notices;
